import React, { Fragment, useEffect, useState } from 'react';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import Button from '../../../components/button/Button';
import Toolbar from '../../../components/toolbar/Toolbar';
import Table from '../../../components/table/Table';

import { initAdressmanagementTableConfig } from './AdressmanagementTableConfig';
import { deleteAdresse, getAdressen } from '../../../redux/actions/adresse';
import { connect } from 'react-redux';
import { Adresse } from '../../../api';
import InputFieldText from '../../../components/input/floating-label/input-field/InputFieldText';
import { setActiveTab } from '../../../redux/actions/routing';
import {
  resetAdresserfassung,
  setAdresseId,
  setAdresseKopieId,
  setAdresseField,
} from '../../../redux/actions/adresserfassung';

import Modal from '../../../components/modal/Modal';
import { setNotification } from '../../../utils/notificationUtils';
import { INFO } from '../../notification/Notification';
import { StateModel } from '../../../redux/store';
import Pagination from '../../../components/pagination/Pagination';
import { nameof } from '../../../utils/objectUtils';

/**
 * Adressmanagement-Component
 *
 * @returns {JSX.Element} Adressmanagement-Component
 * @constructor
 */
interface AdressmanagmentProps {
  getAdressen: any;
  importAdressen: (adressen: Adresse[]) => void;
  currentAdressen: any;
  setAdresseId: (id: number | undefined) => void;
  resetAdresserfassung: () => void;
  setAdresseKopieId: (copyId: number) => void;
  deleteAdresse: (id: number) => void;
  setActiveTab: (active: string) => void;
  reloadToggle: boolean;
  rowsInGrid: number;
  totalSearchResults: any;
  setAdresseField: (value: any, fieldName: string) => void;
}

const Adressmanagement = (
  props: AdressmanagmentProps & RouteComponentProps
) => {
  const [tableConfig, setTableConfig] = useState(
    initAdressmanagementTableConfig()
  );
  const [data, setData] = useState<Array<any>>([{}]);
  const [selectedRow, setSelectedRow] = useState<number | undefined>(undefined);
  const [query, setQuery] = useState<string>('');
  const [showLoeschen, setShowLoeschen] = useState(false);
  const [page, setPage] = useState(1);

  /**
   * UseEffect wird ausgeführt, wenn sich die
   * Dependency / das Attribut verändert (in eckigen Klammern)
   */
  useEffect(() => {
    searchStart(page);
  }, [props.reloadToggle]);

  useEffect(() => {
    searchStart(1);
  }, [query]);

  useEffect(() => {
    setData(props.currentAdressen);
  }, [props.currentAdressen]);

  const editAdresse = () => {
    if (selectedRow || selectedRow == 0) {
      const adresseId: number = data[selectedRow].id;
      if (adresseId) {
        props.resetAdresserfassung();
        props.setActiveTab('masterdata');
        props.history.push(`/masterdata/adresserfassung/${adresseId}`);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', [], INFO, 5000);
    }
  };

  const copyAdresse = () => {
    if (selectedRow || selectedRow == 0) {
      const adresseId: number = data[selectedRow].id;
      if (adresseId) {
        props.setAdresseId(undefined);
        props.setAdresseField(undefined, nameof<Adresse>('mailTrackTrace'));
        props.setAdresseField(undefined, nameof<Adresse>('kontakt'));
        props.setAdresseField(undefined, nameof<Adresse>('telefon'));
        props.setAdresseField(undefined, nameof<Adresse>('matchcode'));
        props.setAdresseField(undefined, nameof<Adresse>('fremdnummer'));
        props.setAdresseKopieId(adresseId);
        props.setActiveTab('masterdata');
        props.history.push(`/masterdata/adresserfassung`);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', [], INFO, 5000);
    }
  };

  const deleteAdresse = () => {
    if (selectedRow || selectedRow == 0) {
      const adresseId: number = data[selectedRow].id;
      if (adresseId) {
        props.deleteAdresse(adresseId);
        setShowLoeschen(false);
      }
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', [], INFO, 5000);
    }
  };

  /**
   * Steuert die Öffnung vom Modalen Fenster
   */
  const handleOpen = () => {
    if (selectedRow || selectedRow == 0) {
      setShowLoeschen(true);
    } else {
      setNotification('Bitte markieren Sie eine Zeile.', [], INFO, 5000);
    }
  };

  const handleClose = () => {
    setShowLoeschen(false);
  };
  const searchStart = (page: number) => {
    setPage(page);
    props.getAdressen(query, page, props.rowsInGrid);
  };

  return (
    <Fragment>
      <div className='adressmanagement-wrapper'>
        <Toolbar>
          <Link to='/masterdata/adresserfassung'>
            <Button
              tooltip='Adresse hinzufügen'
              classes={'iconButton'}
              key={0}
              onClickHandler={() => {
                props.resetAdresserfassung();
                setActiveTab('masterdata');
              }}
            >
              <i className='far fa-plus-square fa-2x' />
            </Button>
          </Link>
          <Button
            tooltip='Adresse bearbeiten'
            classes={'iconButton'}
            key={1}
            onClickHandler={() => {
              editAdresse();
            }}
          >
            <i className='far fa-edit fa-2x' />
          </Button>
          <Link to='/masterdata/adresserfassung'>
            <Button
              tooltip='Adresse kopieren'
              classes={'iconButton'}
              key={2}
              onClickHandler={() => {
                copyAdresse();
              }}
            >
              <i className='far fa-copy fa-2x' />
            </Button>
          </Link>
          <Button
            tooltip='Adresse löschen'
            classes={'iconButton'}
            key={3}
            onClickHandler={() => {
              handleOpen();
            }}
          >
            <i className='far fa-trash-alt fa-2x color-red' />
          </Button>
          <div className={'search-field-wrapper'}>
            <i className='fas fa-search fa-lg' />
            <InputFieldText
              label='Nummer, Name, PLZ, Ort, etc.'
              name='search'
              classes='search-field'
              onChangeHandler={setQuery}
              maxlength={200}
              value={query}
            />
          </div>
        </Toolbar>
        <GridCellWrapper classes='adressmanagement' label='Adressenmanagement'>
          <Table
            tableConfig={tableConfig}
            setTableConfig={setTableConfig}
            data={data}
            tabSkipIndices={[0]}
            edit={false}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            doubleClickRowHandler={editAdresse}
            searchQueryString={query}
          />
          <Pagination
            onClickHandler={searchStart}
            totalCount={+props.totalSearchResults}
            countPerPage={props.rowsInGrid}
            currentPage={page}
          />
        </GridCellWrapper>
      </div>

      <Modal
        show={showLoeschen}
        closeHandler={handleClose}
        titel='Adresse löschen'
        description={'Soll die Adresse entfernt werden?'}
      >
        <div className='modal-btn-group'>
          <button className='modal-btn' onClick={deleteAdresse}>
            Ja
          </button>
          <button className='modal-btn' onClick={handleClose}>
            Nein
          </button>
        </div>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({
  currentAdressen: state.Adressen.adressenliste,
  reloadToggle: state.Adressen.reloadToggle,
  rowsInGrid: state.UserSession.rowsInGrid,
  totalSearchResults: state.Adressen.totalSearchResults,
});

export default connect(mapStateToProps, {
  getAdressen,
  setAdresseId,
  setAdresseField,
  setAdresseKopieId,
  resetAdresserfassung,
  deleteAdresse,
  setActiveTab,
})(withRouter(Adressmanagement));
